import { motion } from "framer-motion";
import "./ContenidoExtra.css";

function ContenidoExtra({ html, variants }) {
  if (!html) return null;

  return (
    <motion.div className="contenido-extra" variants={variants}>
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </motion.div>
  );
}

export default ContenidoExtra;
